<template>
	<div>
		<div class="full-width section-small bg-gray-light mt-2 mb-4 my-md-5">
			<div class="container">
				<div class="support-videos-app__filtering row">
					<div class="support-videos-app__filtering-col col-md-12 col-lg-3">
						<h3 class="support-videos-app__filter-head">{{ translations?.FilterBy }}</h3>
					</div>
					<div class="support-videos-app__filtering-col col-md-4 col-lg-3">
						<SupportVideoFilter
							filter="Portfolio"
							:filterOptions="filterPortfoliosData"
							v-on:filterChange="filterChange"
						>
							<template v-slot:filterTitle>
								{{ translations?.Portfolio }}
							</template>
						</SupportVideoFilter>
					</div>
					<div class="support-videos-app__filtering-col col-md-4 col-lg-3">
						<SupportVideoFilter
							filter="ProductType"
							:filterOptions="filterProductTypesData"
							v-on:filterChange="filterChange"
						>
							<template v-slot:filterTitle>
								{{ translations?.ProductType }}
							</template>
						</SupportVideoFilter>
					</div>
					<div class="support-videos-app__filtering-col col-md-4 col-lg-3">
						<SupportVideoFilter
							filter="Topics"
							:filterOptions="filterTopicsData"
							v-on:filterChange="filterChange"
						>
							<template v-slot:filterTitle>
								{{ translations?.Topics }}
							</template>
						</SupportVideoFilter>
					</div>
				</div>
			</div>
		</div>
		<div class="support-videos-app__container">
			<template v-if="supportVideos && supportVideos.length === 0">
				<div>
					{{ translations?.NoMatchingSupportVideos }}
				</div>
			</template>
			<template v-else>
				<ul class="support-videos-app__list">
					<li class="support-videos-app__item" v-for="supportVideo in supportVideos" :key="supportVideo.Id">
						<SupportVideoCard
							:title="supportVideo.Title"
							:youtubeID="supportVideo.YouTubeID"
							:thumbnail="supportVideo.Thumbnail"
							:thumbnailImageUrl="supportVideo.ThumbnailImageUrl"
							:urlName="supportVideo.UrlName"
							:id="supportVideo.Id"
							:portfolio="supportVideo.Portfolio.PersistedValue"
							:productType="supportVideo.ProductType.Text"
							:topic="supportVideo.Topic.Text"
							:stepId="supportVideo.StepId"
							:videoDescription="supportVideo.VideoDescription"
						></SupportVideoCard>
					</li>
				</ul>
			</template>
		</div>
		<div class="text-center section-small-md-up" v-if="buttonEnabled === true">
			<button @click="showAllTrigger" class="btn btn-primary btn-lg">{{ translations?.ShowMore }}</button>
		</div>
		<div class="load-indicator" :class="{ 'state-visible': loadingResults === true }">
			<div class="load-indicator__indicator"></div>
			<span class="load-indicator__text">{{ translations?.Loading }}</span>
		</div>
		<div class="load-indicator-cover" :class="{ 'state-visible': loadingResults === true }"></div>
	</div>
</template>

<script lang="ts">
import SupportVideoCard from "Vue/components/supportVideos/SupportVideoCard.vue";
import SupportVideoFilter from "Vue/components/supportVideos/SupportVideoFilter.vue";

import {
	ISupportVideos,
	ISupportVideosPortfolio,
	ISupportVideosTopic,
	ISupportVideosProductType,
	ISupportVideosVideo,
	ISupportVideosTranslations
} from "Vue/interfaces/Interfaces";
import {GetSupportVideosData} from "Api/apis";

export default {
	name: "SupportVideos",
	components: {
		SupportVideoCard,
		SupportVideoFilter
	},
	data() {
		return {
			loadingResults: false,
			buttonEnabled: false,
			supportVideos: [] as ISupportVideosVideo[],
			filterPortfoliosData: [] as ISupportVideosPortfolio[],
			filterProductTypesData: [] as ISupportVideosProductType[],
			filterTopicsData: [] as ISupportVideosTopic[],
			productType: '',
			topic: '',
			portfolio: '',
			translations: {} as ISupportVideosTranslations,
			showAll: false
		};
	},
	methods: {
		async getSupportVideosData() {
			let supportVideosDiv = document.getElementById('supportVideosData');
			return JSON.parse(supportVideosDiv.getAttribute('data-page-data'));
		},

		async setData() {
			const supportVideoData:ISupportVideos = await this.getSupportVideosData();
			this.supportVideos = supportVideoData.Videos;
			this.filterPortfoliosData = supportVideoData.Portfolios;
			this.filterProductTypesData = supportVideoData.ProductTypes;
			this.filterTopicsData = supportVideoData.Topics;
			if(supportVideoData.HasMoreResults === true) {
				this.buttonEnabled = true;
			}
		},

		async checkForExistingParams() {
			let urlParams = new URLSearchParams(window.location.search);
			if(urlParams.has('portfolio') || urlParams.has('productType') || urlParams.has('topic') || urlParams.has('showAll')) {
				if(urlParams.has('portfolio')) {
					this.portfolio = urlParams.get('portfolio');
				}
				if(urlParams.has('productType')) {
					this.productType = urlParams.get('productType');
				}
				if(urlParams.has('topic')) {
					this.topic = urlParams.get('topic');
				}
				if(urlParams.has('showAll')) {
					this.showAll = urlParams.get('showAll');
				}
			}
		},

		async showAllTrigger() {
			this.showAll = true;
			let path = window.location.href;
			let pathWithoutParams = path.indexOf('?') !== -1 ? window.location.href.split('?')[0] : window.location.href
			history.replaceState(null, 'Baldwin Support Videos', `${pathWithoutParams}?portfolio=${this.portfolio}&productType=${this.productType}&topic=${this.topic}&showAll=${this.showAll}`);

			await this.filterRequest();
		},

		async filterChange(value) {
			let urlParams = new URLSearchParams(window.location.search);

			if(value[0] === 'ProductType') {
				this.productType = value[1] ? value[1] : '';
				this.portfolio = urlParams.get('portfolio') ? urlParams.get('portfolio') : '';
				this.topic = urlParams.get('topic') ? urlParams.get('topic') : '';
			}
			if(value[0] === 'Portfolio') {
				this.portfolio = value[1] ? value[1] : '';
				this.productType = urlParams.get('productType') ? urlParams.get('productType') : '';
				this.topic = urlParams.get('topic') ? urlParams.get('topic') : '';
			}
			if(value[0] === 'Topics') {
				this.topic = value[1] ? value[1] : '';
				this.productType = urlParams.get('productType') ? urlParams.get('productType') : '';
				this.portfolio = urlParams.get('portfolio') ? urlParams.get('portfolio') : '';
			}

			let path = window.location.href;
			let pathWithoutParams = path.indexOf('?') !== -1 ? window.location.href.split('?')[0] : window.location.href
			await history.replaceState(null, 'Baldwin Support Videos', `${pathWithoutParams}?portfolio=${this.portfolio}&productType=${this.productType}&topic=${this.topic}&showAll=${this.showAll}`);
			await this.filterRequest();
		},

		async apiRequest() {
			let currentParams = {
				productType: this.productType,
				portfolio: this.portfolio,
				topic: this.topic,
				showAll: this.showAll
			}

			let newSupportVideosData = await GetSupportVideosData(currentParams);
			this.supportVideos = newSupportVideosData.Videos;
			this.filterPortfoliosData = newSupportVideosData.Portfolios;
			this.filterProductTypesData = newSupportVideosData.ProductTypes;
			this.filterTopicsData = newSupportVideosData.Topics;
			this.buttonEnabled = newSupportVideosData.HasMoreResults === true;
		},
		async filterRequest() {
			this.loadingResults = true;
			await this.apiRequest();
			setTimeout(() => {
				this.loadingResults = false;
			}, 1000)
		},

		getTranslations() {
			let supportVideosDiv = document.getElementById('supportVideosData');
			return JSON.parse(supportVideosDiv.getAttribute('data-translations'));
		}
	},
	async created() {
		this.translations = this.getTranslations();
		await this.setData();
		await this.checkForExistingParams();
		await this.filterRequest();
	},
};
</script>
